import {get} from 'lodash';
import {createAction} from 'redux-actions';

import store from '../store';
import {
  SAVE_SIGN,
  REQUEST_CODE,
  VERIFY_CODE_ERROR,
  VERIFY_CODE_SUCCESS,
  CLEAR_STORED_SIGNUP_DATA,
  HOW_DID_YOU_HEAR,
  REFRESH_TOKEN,
  TEMP_USER_TO_REGULAR,
  SHOW_CHANGE_PASSWORD_ERROR,
  HIDE_CHANGE_PASSWORD_ERROR,
  SAVE_INFO,
  SHOW_REQUEST_CODE_ERROR,
  GET_MEMBERSHIP_AGREEMENT
} from '../config/const';

import * as api from './signup-async';
import * as modal from '../reducers/modalReducer';
import {rootPageUri} from '../config/uri';
import {addProduct, cartUpdated} from '../reducers/cartReducer';
import {resetHoldProduct} from '../reducers/holdProductReducer';
import {setTempUser} from '../reducers/userReducer';
import * as overlayingModal from '../reducers/overlayingModalReducer';

import {
  uploadStart,
  uploadFinish
} from '../reducers/uploadReducer';
import { getCustomerTempId } from '../selectors/customer_selectors';
import { pushWithQueryParams } from '../services/uri';
import { isEmailVerificationRequired } from '../selectors/configSelectors';

export const saveSign = createAction(SAVE_SIGN, sign => sign);
export const requestCode = createAction(REQUEST_CODE, data => data);
export const verifyCodeSuccess = createAction(VERIFY_CODE_SUCCESS, data => data);
export const verifyCodeError = createAction(VERIFY_CODE_ERROR);
export const clearStoredSignupData = createAction(CLEAR_STORED_SIGNUP_DATA);
export const howDidYouHear = createAction(HOW_DID_YOU_HEAR, string => string);
export const refreshTokenSuccess = createAction(REFRESH_TOKEN, token => token);
export const tempUserToRegular = createAction(TEMP_USER_TO_REGULAR);
export const showChangePasswordError = createAction(SHOW_CHANGE_PASSWORD_ERROR);
export const hideChangePasswordError = createAction(HIDE_CHANGE_PASSWORD_ERROR);
export const showRequestCodeError = createAction(SHOW_REQUEST_CODE_ERROR);
export const saveInfo = createAction(SAVE_INFO, info => info);
export const getMembershipAgreement = createAction(GET_MEMBERSHIP_AGREEMENT, data => data);
// export const savePasswordSuccess = createAction(SAVE_PASSWORD_SUCCESS);

export function startGetMembership() {
  return dispatch => {
    dispatch(uploadStart());
    api.getMembership().then(res => {
      if (res.data.resultCode === 'SUCCESS') {
        dispatch(getMembershipAgreement(res.data.data));
      } else {
        dispatch(modal.openModal({
          modalType: 'HOW_DID_YOU_HEAR',
          modalProps: {}
        }));
      }
      dispatch(uploadFinish());
    });
  };
}
export function startRefreshToken(token) {
  return dispatch => {
    api.refreshToken(token).then(
      response => dispatch(refreshTokenSuccess(response.data.token)),
      error => console.log(error)
    );
  };
}

export function startActivateUser(password, signupData) {
  return dispatch => {
    api.activateUser(password, signupData).then(
      (/* response */) => {

        dispatch(modal.hideModal());
        dispatch(tempUserToRegular());
        dispatch(clearStoredSignupData());
        // check if user has holded product
        const holdProduct = store.getState().holdProduct;
        if (holdProduct && holdProduct.type === 'cart') {
          dispatch(addProduct(holdProduct.product));
          dispatch(cartUpdated());
          dispatch(resetHoldProduct());
        }
        if (holdProduct && holdProduct.type === 'short') {
          // navigate to correct url
          dispatch(pushWithQueryParams(process.env.PUBLIC_URL + holdProduct.url));
          // set products
          // dispatch(setProductsState(holdProduct.products));
          // set position
          setTimeout(() => {
            dispatch({
              type: 'RESET_SCROLL_TOP',
              payload: store.getState().view.pos
            });
          }, 100);
          // open modal
          setTimeout(() => {
            dispatch(modal.openModal({
              modalType: '1X_PRODUCT_VIEW',
              modalProps: {
                product: holdProduct.product,
                productIndex: holdProduct.index
              }
            }));
            dispatch(resetHoldProduct());
          }, 300);
          return;
        }
        dispatch(pushWithQueryParams(rootPageUri));
        dispatch({
          type: 'RESET_SCROLL_TOP',
          payload: store.getState().view.pos
        });
      },
      error => console.log(error)
    );
  };
}

export function startVerifyCode(customerId, code) {
  return dispatch => {
    api.verifyCode(customerId, code).then(
      response => {
        dispatch(verifyCodeSuccess(response));
        dispatch(setTempUser({
          ...response.data,
          isFetched: true
        }));
        dispatch(modal.hideModal());
        dispatch(modal.openModal({
          modalType: 'PASSWORD_FORM',
          modalProps: {}
        }));
      },
      error => {
        dispatch(verifyCodeError());
      }
    );
  };
}

export function startRequestCode() {
  return (dispatch, getState) => {
    const customerId = getCustomerTempId(getState());

    api.requestCode(customerId).then(
      (response) => {
        if (isEmailVerificationRequired(getState())) {
          dispatch(modal.openModal({
            modalType: 'SIGNUP_AUTH_CONFIRM_FORM',
            modalProps: {},
          }));
          return;
        }

        const authCode = get(response, 'data.data.token');

        dispatch(modal.hideModal());
        dispatch(requestCode(response));
        dispatch(startVerifyCode(customerId, authCode));
      },
      error => console.error('Auth Code Request error:', error),
    );
  };
}

export function startReRequestCode(customerId) {
  return dispatch => {
    api.requestCode(customerId).then(
      response => {
        dispatch(requestCode(response));
      },
      error => console.log(error)
    );
  };
}

export function startChangePassword(values) {
  return dispatch => {
    dispatch(hideChangePasswordError());
    api.changePassword(values).then(
      response => {
        if (response.data.resultCode === 'FAIL') {
          dispatch(showChangePasswordError(response.data.resultReason));
          return;
        }
        dispatch(modal.hideModal());
        dispatch(pushWithQueryParams(rootPageUri));
      },
      error => console.log(error)
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/signup-sync.js